import { createFileRoute, redirect } from '@tanstack/react-router';
import { WinNumberPage } from '@/components/race-picture';
import { isVoteGoalOn } from '@/config/customerConfig';
import { myCampaignsQuery } from '@/hooks/queries';
import { authService } from '@/services/authService';
import { useCampaignStore } from '@/stores';

export const Route = createFileRoute('/win-number')({
  beforeLoad: async ({ context }) => {
    if (!isVoteGoalOn()) throw redirect({ to: '/' });
    // The stored session, not context.auth: on a fresh page load the router checks before AuthContext has read it.
    if (!authService.isAuthenticated()) return;
    // A campaign not chosen yet this session still counts: the app picks one on the way in.
    if (!useCampaignStore.getState().selectedCampaign) {
      const campaigns = await context.queryClient.fetchQuery(myCampaignsQuery()).catch(() => []);
      if (!campaigns.length) return;
    }
    throw redirect({ to: '/app/vote-goal', search: { from: 'win-number' } });
  },
  component: WinNumberPage,
});
